export default "__VITE_ASSET__Csd5E1jm__"